import angular from 'angular';
import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('Payment', PaymentData);

    PaymentData.$inject = ['UtilSvc', '$translate', 'CURRENCY'];

    /* @ngInject */
    function PaymentData(UtilSvc, $translate, CURRENCY) {
        Payment.prototype = {
            build: build,
            getStatusLabel: getStatusLabel,
            getTypeClientLabel: getTypeClientLabel,
            getCreatedDate: getCreatedDate,
            getSellerLabel: getSellerLabel,
        };

        function Payment(paymentData) {
            if (paymentData) {
                this.build(paymentData);
            }
        }

        return Payment;

        function build(paymentData) {
            this.eid = paymentData.eid || null;
            this.status = paymentData.status || null;
            this.createdDate = UtilSvc.parseDate(paymentData.createdDate) || null;
            this.updatedDate = UtilSvc.parseDate(paymentData.updatedDate) || null;
            this.buyerType = paymentData.buyerType || null;
            this.buyer = paymentData.buyer || null;
            this.invoiceId = paymentData.invoiceId || null;
            this.amount = paymentData.amount || null;
            this.sellerName = paymentData.sellerName || null;
            this.sellerFiscalId = paymentData.sellerFiscalId || null;
            this.sellerLegalId = paymentData.sellerLegalId || null;
            this.currency = _.find(CURRENCY, { code: paymentData.currency }).symbol || null;
        }

        function getStatusLabel() {
            return $translate.instant('payment.form.status.' + angular.lowercase(this.status));
        }

        function getTypeClientLabel() {
            return $translate.instant('payment.form.buyer_type.' + angular.lowercase(this.buyerType));
        }

        function getCreatedDate() {
            return this.createdDate;
        }

        function getSellerLabel() {
            return this.sellerName + ' (' + (this.sellerFiscalId || this.sellerLegalId) + ')';
        }
    }
})();
